import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { QueryOption } from "libs/react-query";
import * as KeyFactory from "./user-query-key-factory";
/**
 * Gets the user by id
 */
export const getUser = ({ userId }: { userId: string | null }) => {
  return userId === null ? Promise.reject(new Error("Invalid id")) : Brm.userApi.getUserByID(userId);
};

interface IUserProps {
  userId: string | null;
  options?: QueryOption<typeof getUser>;
}

/**
 * Custom hook for getting the user
 *
 * @param {string} userId - uuid of user
 * @param {object} options - react-query options
 * @returns
 */
export const useUser = ({ userId, options = {} }: IUserProps) => {
  return ReactQuery.useQuery({
    ...options,
    queryKey: KeyFactory.userKeys.user(userId),
    queryFn: () => getUser({ userId }),
  });
};
